<template>
  <el-form
    ref="basicDataForm"
    v-loading="loading"
    :model="shop"
    :rules="rules"
    label-position="top"
    autocomplete="off"
    :validate-on-rule-change="true"
    @submit.native.prevent="store"
  >
    <el-switch
      v-model="shop.is_active"
      active-text="Aktív"
      inactive-text="Inaktív"
      name="Státusz"
      style="margin-bottom: 20px"
    />
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="name"
          label="Név"
        >
          <el-input
            v-model="shop.name"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="partner_id"
          label="Partner"
        >
          <el-select
            v-model="shop.partner_id"
            filterable
            remote
            :remote-method="searchPartners"
            :loading="remoteLoading"
            style="width: 100%;"
          >
            <el-option
              v-for="partner in partners"
              :key="partner.id"
              :label="'#' + partner.id +' ' + partner.company.name"
              :value="partner.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="email"
          label="E-mail"
        >
          <el-input
            v-model="shop.email"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="phone"
          label="Telefon"
        >
          <el-input
            v-model="shop.phone"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="send_invoice_email"
        >
          <el-checkbox
            v-model="shop.send_invoice_email"
          >
            Számla küldése Email -ben
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="shop_category_id"
          label="Kategória"
        >
          <el-select
            v-model="shop.shop_category_id"
            style="width: 100%;"
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="shop_chain_id"
          label="Üzletlánc"
        >
          <el-select
            v-model="shop.shop_chain_id"
            style="width: 100%;"
          >
            <el-option
              v-for="shopChain in shopChains"
              :key="shopChain.id"
              :label="shopChain.name"
              :value="shopChain.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="representative_users"
          label="Területi képviselő(k)"
        >
          <el-select
            v-model="shop.representative_users"
            style="width: 100%;"
            filterable
            multiple
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="`${user.last_name} ${user.first_name} (@${user.username})`"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="location_id"
          label="Terület"
        >
          <el-select
            v-model="shop.location_id"
            style="width: 100%;"
          >
            <el-option
              v-for="location in locations"
              :key="location.id"
              :label="location.value"
              :value="location.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <h4>Cím</h4>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Irányítószám"
          prop="address.postal_code"
        >
          <el-input
            v-model="shop.address.postal_code"
            @change="onZipChange"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Város"
          prop="address.city"
          v-loading="addressLoading"
        >
          <el-input
            v-model="shop.address.city"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Ország"
          prop="address.country_id"
          v-loading="addressLoading"
        >
          <el-select
            v-model="shop.address.country_id"
            value-key="id"
            style="width: 100%;"
            filterable
          >
            <el-option
              v-for="country in countries"
              :key="country.id"
              :value="country.id"
              :label="country.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          v-loading="addressLoading"
          label="Megye"
          prop="address.county_id"
        >
          <el-select
            v-model="shop.address.county_id"
            value-key="id"
            style="width: 100%;"
            filterable
          >
            <el-option
              v-for="county in counties"
              :key="county.id"
              :value="county.id"
              :label="county.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Cím"
          prop="address.address"
        >
          <el-input
            v-model="shop.address.address"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import streetSuffixes from '../../../../../config/streetSuffixes';

export default {
  props: ['shop'],
  data() {
    return {
      loading: false,
      remoteLoading: false,
      suffixes: streetSuffixes,
      addressLoading: false,
      partners: [],
      rules: {
        name: [
          {
            required: true,
            message: 'Név megadása kötelező',
            trigger: 'change'
          }
        ],
        partner_id: [
          {
            required: true,
            message: 'Partner megadása kötelező',
            trigger: 'change'
          }
        ],
        'address.postal_code': [
          {
            required: true,
            message: 'Irányítószám megadása kötelező',
            trigger: 'change'
          }
        ],
        'address.country_id': [
          {
            required: true,
            message: 'Ország megadása kötelező',
            trigger: 'blur'
          }
        ],
        'address.city': [
          {
            required: true,
            message: 'Város megadása kötelező',
            trigger: 'change'
          }
        ],
        'address.address': [
          {
            required: true,
            message: 'Cím kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['user/users'];
    },
    countries() {
      return this.$store.getters['country/countries'];
    },
    counties() {
      return this.$store.getters['county/counties'];
    },
    categories() {
      return this.$store.getters['shopCategory/shopCategories'];
    },
    shopChains() {
      return this.$store.getters['shopChain/shopChains'];
    },
    locations() {
      return this.$store.getters['location/locations'];
    },
    emailNeeded() {
      return !!this.shop.email
    }
  },
  watch: {
    shop: {
      handler(newVal) {
        if (this.shop && this.shop.partner_id) {
          this.partners.push(this.shop.partner);
        }
      }
    }
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    if (!this.countries.length) {
      requiredFetches.push(this.$store.dispatch('country/fetchAll'));
    }
    if (!this.counties.length) {
      requiredFetches.push(this.$store.dispatch('county/fetchAll'));
    }
    if (!this.shopChains.length) {
      requiredFetches.push(this.$store.dispatch('shopChain/fetchAll'));
    }
    if (!this.categories.length) {
      requiredFetches.push(this.$store.dispatch('shopCategory/fetchAll'));
    }
    if (!this.locations.length) {
      requiredFetches.push(this.$store.dispatch('location/fetchAll'));
    }
    await Promise.all(requiredFetches);

    this.loading = false;
  },
  methods: {
    suffixFilter(value) {
      this.suffixes = streetSuffixes;
      if (value) {
        this.suffixes = this.suffixes.filter(suffix => suffix.startsWith(value));
      }
      this.shop.address.street_suffix = value;
    },
    async onZipChange() {
      this.addressLoading = true;
      const data = await axios.get('/api/city/' + this.shop.address.postal_code);
      if (data) {
        this.shop.address = Object.assign({}, this.shop.address, {
          ...this.shop.address,
          city: data.city,
          county_id: data.county_id,
          country_id: data.country_id,
        });
      } else {
        this.shop.address = Object.assign({}, this.shop.address, {
          ...this.shop.address,
          city: null,
          county_id: null,
        });
      }
      this.addressLoading = false;
    },
    async searchPartners(query) {
      this.remoteLoading = true;
      if (!query) {
        this.partners = [];
      } else {
        const queryString = new URLSearchParams({
          name: query,
        });
        this.partners = await this.$store.dispatch('partner/search', '?' + queryString.toString());
      }
      this.remoteLoading = false;
    }
  }
};
</script>
